'use client';

import { useQuery } from '@tanstack/react-query';

import { JWT_STORAGE_KEY, USER_ID_STORAGE_KEY } from 'src/utils/constants';

import { restClient } from 'src/lib/api';

export const useOrdersList = ({ statusOfOrder = '', search = '', fromDate = '', toDate = '' }) => {
  const token = sessionStorage.getItem(JWT_STORAGE_KEY);
  const userID = sessionStorage.getItem(USER_ID_STORAGE_KEY);

  return useQuery({
    queryKey: ['getOrdersList', statusOfOrder], // unique key
    queryFn: () =>
      restClient
        .get('orders/getOrdersBystatus', {
          params: {
            token,
            userID,
            statusOfOrder,
            search,
            fromDate,
            toDate,
          },
        })
        .then((res) => res?.data),
    enabled: !!token && !!userID, // only run if creds are present
    // staleTime: 1000 * 60 * 5, // optional: cache results for 5 minutes
    keepPreviousData: true, // optional: keeps previous data during transitions
  });
};
export const useOrdersDetails = (orderId) => {
  const token = sessionStorage.getItem(JWT_STORAGE_KEY);
  const userID = sessionStorage.getItem(USER_ID_STORAGE_KEY);

  return useQuery({
    queryKey: ['orderDetails', orderId], // unique key
    queryFn: () =>
      restClient
        .get('orders/orderDetails', {
          params: {
            orderID: orderId,
          },
        })
        .then((res) => res?.data?.success),
    enabled: !!token && !!userID && !!orderId, // only run if creds are present
    // staleTime: 1000 * 60 * 5, // optional: cache results for 5 minutes
    keepPreviousData: true, // optional: keeps previous data during transitions
  });
};
